import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import { pickState } from '../_core/pickState';
import { Store } from '../_core/types/Store';
import useApiStore from '../apiStore/useApiStore';
import useDashboardStore from '../dashboardStore/useDashboardStore';
import useParameterStore from '../parameterStore/useParameterStore';
import { keysToPersist, leadChannelStore } from './leadChannelStore';
import { LeadChannelState } from './types/LeadChannelState';

const useLeadChannelStore: Store<LeadChannelState> =
  createStore<LeadChannelState>({
    creator: leadChannelStore({
      useApiStore: lazyDependency(() => useApiStore),
      useDashboardStore: lazyDependency(() => useDashboardStore),
      useParameterStore: lazyDependency(() => useParameterStore),
    }),
    id: 'leadChannel',
    ignoreReset: true,
    middlewares: {
      devtools: true,
      persist: {
        partialize(state): LeadChannelState {
          return pickState(state, keysToPersist);
        },
      },
    },
  });

export default useLeadChannelStore;
